module.exports = __webpack_public_path__ + "8bfb8b0d95cfd68b31e0775223b15406.svg";